// extracted by mini-css-extract-plugin
export default {"Navm":"Navm_Navm__emb3n","hidden":"Navm_hidden__8xe4S","contents":"Navm_contents__7lIEr","Nav":"Navm_Nav__13xjk","sidebar":"Navm_sidebar__eTPCL"};